/* eslint-disable */
module.exports = {
  pageView(pathname) {
    if (typeof ga === 'function') {
      ga('send', 'pageview', pathname);
    }
  }
};
/* eslint-enable */